import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHMSStore, selectLocalPeer } from "@100mslive/react-sdk";
import RemoteLayout from "./layout";
import { WorkshopContext } from "../../contexts/workshop.context";
import { defaultRoles } from "../../util/workshop.util";
import { Conference } from "../../components/videoCalling";
import { useChangeRole } from "../../hooks/useChangeRole";

const WaitingRoom = ({ demoWorkshop = false }) => {
  const { t } = useTranslation();
  const { changeToDefaultRole } = useChangeRole();
  const localPeer = useHMSStore(selectLocalPeer);

  const { socket, user: { role } = {} } = useContext(WorkshopContext);

  const handleStartWorkshop = () => {
    socket.emit("startWorkshop");
  };

  useEffect(() => {
    if (!localPeer || !role) return;

    const timer = setTimeout(() => {
      changeToDefaultRole();
    }, 1000);

    // Cleanup function to clear the timeout if component unmounts or dependencies change
    return () => clearTimeout(timer);
  }, [localPeer, role]);

  return (
    <RemoteLayout
      buttonText={t("waitingRoom.button") + " →"}
      showParticipants={true}
      onButtonClick={role !== defaultRoles.participant ? handleStartWorkshop : undefined}>
      {/* Header */}

      <div className="flex flex-col items-center mb-6 text-white-100">
        <h1 className="text-2xl md:text-4xl font-medium flex items-center gap-2">
          <span className="text-3xl">⌛</span> {t("waitingRoom.heading")}
        </h1>
      </div>

      {/* Message */}
      <p className="max-w-2xl text-lg mx-auto mb-8 text-center text-white-100">
        {t("waitingRoom.message")}
      </p>

      {/* Main content */}

      <div className="flex flex-col md:flex-row gap-4 items-center">
        <div className="bg-orange-50 rounded-lg p-6 max-w-md h-fit">
          <h2
            className="text-orange-500 font-bold text-xl mb-4"
            dangerouslySetInnerHTML={{ __html: t("waitingRoom.instructions.heading") }}
          />
          <p
            className="font-bold my-2"
            dangerouslySetInnerHTML={{ __html: t("waitingRoom.instructions.subHeading") }}
          />
          <ul
            className="list-inside"
            dangerouslySetInnerHTML={{ __html: t("waitingRoom.instructions.bullets") }}
          />
        </div>
        <div className="mx-auto mb-12 w-full">
          <Conference smallSpace demoWorkshop={demoWorkshop} />
        </div>
      </div>
    </RemoteLayout>
  );
};

export default WaitingRoom;
